module.exports = __webpack_public_path__ + "static/media/hero-6.1201ad92.png";